module.exports = __webpack_public_path__ + "static/CRS_09_new-a5f4fc72db5ff8f696a01f7030cd675d.svg";